import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import { jobsDesc } from "../../StaticData/applytojob";
import { Helmet } from "react-helmet";
import "../../pages/Careers/Careers.css";

const JobDesc = () => {
  const jobPathName = window.location.pathname;
  const [job] = useState(jobsDesc.find((job) => job.link === jobPathName));
  console.log(job.jobdesc, "job222");

  return (
    <div className="jobdesc-page">
      <Helmet>
        <title>{job && job?.jobtitle} | Idexcel</title>
        <meta
          content="current openings usa, current openings india"
          name="keywords"
        />
        <meta
          content="Ready to explore a career with Idexcel? Click here and explore our job openings."
          name="description"
        />
      </Helmet>
      <motion.div
        className="Productright"
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <section className="insights-sections">
          <Container className="h-100">
            <Row className="h-100 align-items-center">
              <Col lg={9}>
                <div className="content">
                  <motion.div
                    className="Productleft"
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    viewport={{ once: true, amount: 0.7 }}
                  >
                    <h1 className="text-white">{job && job?.jobtitle}</h1>
                    <p className="text-white"> Bengaluru</p>
                    {/* Display the job title */}
                  </motion.div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </motion.div>

      <Container className="job-description">
        <section
          className="col-xl-8 col-12 py-5"
          style={{ textAlign: "justify" }}
        >
          <h3>Job Description:</h3>
          <ul style={{ fontSize: "22px" }}>
            {/* Map through the jobdesc array and display each item as a list */}
            {job &&
              job?.jobdesc?.map((point, index) => <li key={index}>{point}</li>)}
          </ul>

          <h3>Company Profile :</h3>
          <p>
            Idexcel is a Professional Services and Technology Solutions provider
            specializing in Cloud Innovations, Cloud Native Services, Data
            Platforms and Intelligence, Automation & AI. We as Idexcel, are
            proud that for more than 20 years we have provided services that
            implement complex technologies that are innovative, agile, and
            successful and have provided our customers with lasting value.
          </p>
          <p>
            Our name, "Idexcel" is a representation of our core principle "Ideas
            to Excellence". We are relentlessly driven by results and take pride
            in our customer-centric engagement models. We blend our client's
            needs with proven delivery models and highly talented execution
            teams to deliver an exceptional customer experience.
          </p>
          <p>
            Headquartered in Herndon, Virginia, Idexcel has offices and delivery
            locations in the US, Europe, and Asia supporting global clients.
          </p>
          <div className="d-flex flex-row align-items-center">
            <a href="/careers/apply-to-job" className="button mt-5 ">
              Apply Now
            </a>
          </div>
        </section>
      </Container>
    </div>
  );
};

export default JobDesc;
